var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasDateValue)?_c('span',{staticClass:"grey--text"},[_vm._v(" "+_vm._s(_vm._f("datetime")(_vm.selectModel(_vm.modelValue, _vm.dataSelectorKey)))+" ("+_vm._s(_vm._f("fromNow")(_vm.selectModel(_vm.modelValue, _vm.dataSelectorKey)))+") ")]):_c('span',[_vm._v("--")])
}
var staticRenderFns = []

export { render, staticRenderFns }